var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home",class:{'active': _vm.activeLoader}},[(_vm.activeLoader)?[_c('LoaderBarBox')]:_vm._e(),_c('router-view',{attrs:{"name":"mainBox"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }